import { render, staticRenderFns } from "./TituloPagamentos.vue?vue&type=template&id=b28dca2e&"
import script from "./TituloPagamentos.vue?vue&type=script&lang=js&"
export * from "./TituloPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports